import { Component, OnInit } from '@angular/core';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { ICompany } from 'src/app/interfaces/company';
import { ErrorsService } from 'src/app/services/common/errors.service';
//import * as moment from "jalali-moment";

import { IConfirm } from 'src/app/interfaces/confirm';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { IBranch } from 'src/app/interfaces/branch';
import { MarkManagementService } from 'src/app/services/http/business/markManagement/mark-management.service';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { MarkClassificationEntryComponent } from '../mark-classification-entry/mark-classification-entry.component';
import { IEducationPackage } from 'src/app/interfaces/educationPackage';
import { EducationPackageService } from 'src/app/services/http/business/educationPackage/education-package.service';

@Component({
  selector: 'app-mark-classification-list',
  templateUrl: './mark-classification-list.component.html',
  styleUrls: ['./mark-classification-list.component.css']
})
export class MarkClassificationListComponent implements OnInit {

  param: any;
  errObject: any;
  isOwner: boolean;
  errors = new Array();
  pageSize: number;
  queryParam={};
  pageIndex: number;
  companyList: ICompany;
  branchList: IBranch;
  companySelected: String;
  CompanyEncryptId: string;
  eduPackageList: IEducationPackage;
  filter: any;

  displayedColumns: string[] = [
    "MarkClassificationType",
    "Package",
    "range",
    // "MinMark",
    // "MaxMark",
    // "ContainMin",
    // "ContainMax",
    "status",
    'function'
  ];
  dataSource = new MatTableDataSource();


  constructor(
    private dialog: MatDialog,
    public translate: TranslateService,
    private eduPackageService: EducationPackageService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    private markManagementService: MarkManagementService,
  ) {}

  ngOnInit() {
    //this.refresh();
    this.getEduPackage();
  }

  getColor(e) {
    switch (e.IsActive) {
      case true:
        return "custom-chips primary";
      case false:
        return "custom-chips accent";
    }
  }
  
  getEduPackage() {
    this.eduPackageService.getList().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      err => {
        console.log(err);
      }
    );
  }
  

  setParamsList(id:number) {
   
    //Id => EducationPackage
    this.queryParam["Id"]=id;
    this.refresh();
  }
  // get list mark-type
  refresh() {
   
    this.markManagementService.markClassificationList(this.queryParam).subscribe(res => {
     
      console.log(res);
      this.dataSource = res;

    });
  }

  // create  Classification
  add() {
    this.dialog.open(MarkClassificationEntryComponent,
      {
        data:{
          IsUpdate : false
        } ,
         disableClose: true ,
         
      })
      .afterClosed()
      .subscribe(() => {
       
        this.refresh();
      });
  }
  // update Classification
  edit(param: any) {
   
    param["IsUpdate"]=true;
    this.dialog.open(MarkClassificationEntryComponent, {
      data: param,
      disableClose: true
    })
      .afterClosed().subscribe(() => {
       
        this.refresh();
      });
  }

  delete(data: any) {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.cancel", {
        name: this.translate.get("label.category")
      }),
      alert:null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog.open(ConfirmComponent, {
      width: "300px",
      data: confirm
    })
      .afterClosed()
      .subscribe(
        res => {
          if (res) {
            this.markManagementService.delete({ Id: data.Id }).subscribe(() => {
             
              this.snackBar.OpenSnackBar(
                this.translate.get("success.delete"),
                "ok",
                5000,
                SoundEnum.beep
              );
              this.refresh();
            }, () => {

              this.snackBar.OpenSnackBar(
                this.translate.get("error.delete"),
                "ok",
                5000,
                SoundEnum.beep
              );

            });
          }
        },
        err => {
          this.errorService.recordHasBennUsed(err);
        }
      );
  }
}
